import BaseAction from './BaseAction.js';

class BaseAutomationAction extends BaseAction {
    serialize(action, id) {
        let json = super.serialize(action, id);
        action = action.payload;

        if (action === undefined) {
            return json;
        }

        // need to know what track -> parameter -> automation
        // this action refers to

        // automation contains parameter which can give you track
        let {automation} = action;
        if (automation === undefined) {
            return json;
        }
        let {parameter} = automation;

        json.automation = automation.id;
        json.parameter = parameter; //parameter.getJson();
        return json;
    }

    deserialize(json) {
        let action = super.deserialize(json);
        let {payload} = action;

        return action;
    }
}

export default BaseAutomationAction;
